// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NrtBOCrnbrEqJGreOqHg{box-shadow:inset 0 0 0 1px var(--border-neutral-default);border-radius:6px;padding:4px}.Yj47VaRLX0O1kHQxp1ZJ{flex-direction:row;justify-content:space-between;align-items:center;gap:4px;min-height:32px;padding:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NrtBOCrnbrEqJGreOqHg`,
	"content": `Yj47VaRLX0O1kHQxp1ZJ`
};
export default ___CSS_LOADER_EXPORT___;
